<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="invoiceApplicationDetails"
        :table-action="true"
        @delete="deleteHandle"
        @select="selectHandle"
        @reset="resetHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="开票名称" prop="invoiceContent">
            <el-input v-model="filter.invoiceContent" clearable/>
          </el-form-item>
          <el-form-item label="物料编号" prop="materialNo">
            <el-input v-model="filter.materialNo" clearable/>
          </el-form-item>
          <el-form-item label="物料描述" prop="materialName">
            <el-input v-model="filter.materialName" clearable/>
          </el-form-item>
          <el-form-item label="类型">
            <el-select v-model="filter.type" clearable placeholder="请选择类型">
              <el-option label="销售订单" :value="'销售订单'"/>
              <el-option label="发货单" :value="'发货单'"/>
            </el-select>
          </el-form-item>
          <el-form-item label="规格型号" prop="specification">
          <el-input v-model="filter.specification" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </viewTable>
    <order-confirmation-record-edit
        :visible.sync="editVisible"
        :data="editData"
        @submit="submitHandle"
    />
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";

  export default {
    name: "InvoiceApplicationDetailList",
    components: { viewTable },
    data() {
      return {
        limits: {
          addAuth: false,
          editAuth: this.$auth(762),
          delAuth: this.$auth(763),
        },
        filter: {
          isEnd: '',
          productionNo: '',
          station: '',
          componentMaterialNo: '',
          componentBarcode: '',
          createIpAddress: '',
          endIpAddress: '',
          standardCode: '',
          procedureName: '',
        },
        selection: [],
        editVisible: false,
        editData: {},
        columnsProperty: [
          {
          tooltip: true, key: "invoiceApplicationNo", width: 180, align: "center" },
          {
            tooltip: true, key: "invoiceContent", width: 240, align: "center" },
          {
            tooltip: true, key: "statusName", width: 130, align: "center" },
          {
            tooltip: true, key: "customerName", width: 180, align: "center" },
          {
            tooltip: true, key: "customerNo", width: 130, align: "center" },
          {
            tooltip: true, key: "invoiceVATNO", width: 130, align: "center" },
          {
          tooltip: true, key: "specifications", width: 180, align: "center" },
          {
          tooltip: true, key: "type", width: 100, align: "center" },
          {
          tooltip: true, key: "materialNo", width: 160, align: "center" },
          {
          tooltip: true, key: "materialName", width: 160, align: "center" },
          {
          tooltip: true, key: "finalTotalTaxPrice", width: 100, align: "center" },
          {
          tooltip: true, key: "taxTypeCode", width: 200, align: "center"},
          {
          tooltip: true, key: "finalTotalNetPrice", width: 100, align: "center"},
          {
            tooltip: true, key: "taxTypeName", width: 150, align: "center"},
          {
            tooltip: true, key: "finalTotalPrice", width: 100, align: "center"},
          {
            tooltip: true, key: "taxRate", width: 100, align: "center"},
          {
            tooltip: true, key: "discountTaxPrice", width: 100, align: "center"},
          {
            tooltip: true, key: "discount", width: 100, align: "center"},
          {
            tooltip: true, key: "totalTaxPrice", width: 100, align: "center"},
          {
            tooltip: true, key: "unitPrice", width: 100, align: "center"},
          {
            tooltip: true, key: "totalPrice", width: 100, align: "center"},
          {
            tooltip: true, key: "totalNetPrice", width: 100, align: "center"},
          {
          tooltip: true, key: "note", width: 150, align: "center" },
          // { key: "action", width: 150, align: "center", slot: "action" },
        ],
      };
    },
    mounted() {
    },
    methods: {
      selectHandle(selection) {
        this.selection = selection;
      },
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      deleteHandle(row) {
        this.$http.delete("basic", "orderConfirmationRecords", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
      resetHandle(filter) {
        this.filter = filter;
      },
      addEditHandle(row) {
        this.editData = row || {};
        this.editVisible = true;
      },
      submitHandle(form) {
        if (form.pkId) {
          // 编辑
          this.$http.put("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("编辑成功");
            }
          });
        } else {
          // 新增
          this.$http.post("basic", "orderConfirmationRecords", form).then((resp) => {
            if (resp.success) {
              this.editVisible = false;
              this.loadData();
              this.$message.success("新增成功");
            }
          });
        }
      },
    },
  };
</script>